<template>
  <div class="collection-config">
    <!-- 顶部筛选区 -->
    <div class="filter-bar f--c fw-w">
      <el-input
        v-model="searchParams.collectionName"
        placeholder="请输入集合名称"
        clearable
        size="medium"
        style="width: 200px; margin-right: 10px; margin-bottom: 10px"
        @blur="handleSearch"
        @clear="handleSearch"
      />
      <el-select
        v-model="searchParams.status"
        placeholder="集合状态"
        clearable
        size="medium"
        style="width: 150px; margin-right: 10px; margin-bottom: 10px"
        @change="handleSearch"
        @clear="handleSearch"
      >
        <el-option label="全部" value="" />
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-select
        v-model="searchParams.collectionType"
        placeholder="集合类型"
        clearable
        size="medium"
        style="width: 150px; margin-right: 10px; margin-bottom: 10px"
        @change="handleSearch"
        @clear="handleSearch"
      >
        <el-option label="首页" :value="1" />
        <el-option label="定制" :value="2" />
        <el-option label="首页定制" :value="3" />
      </el-select>
      <el-input
        v-model="searchParams.inviteCode"
        placeholder="请输入邀请码"
        clearable
        size="medium"
        style="width: 200px; margin-right: 10px; margin-bottom: 10px"
        @blur="handleSearch"
        @clear="handleSearch"
      />
      <el-select
        v-model="searchParams.inviteCodeListStatus"
        placeholder="邀请码状态"
        clearable
        size="medium"
        style="width: 150px; margin-right: 10px; margin-bottom: 10px"
        @change="handleSearch"
        @clear="handleSearch"
      >
        <el-option label="全部" value="" />
        <el-option label="可用" :value="1" />
        <el-option label="不可用" :value="0" />
      </el-select>
      <el-button type="primary" size="medium" style="margin-bottom: 10px" @click="handleSearch">查询</el-button>
      <el-button type="success" size="medium" style="margin-bottom: 10px" @click="handleAdd">新增集合</el-button>

      <el-button type="primary" size="medium" style="margin-bottom: 10px;" @click="handleShowConfig">配置合集信息</el-button>
    </div>

    <!-- 列表 -->
    <el-table
      height="calc(100vh - 290px)"
      ref="collectionTable"
      :key="tableKey"
      v-loading="loading"
      :data="tableData"
      row-key="id"
      style="width: 100%;"
      :expand-row-keys="expandRowKeys"
      @expand-change="handleExpandChange"
    >
      <el-table-column type="expand">
        <template slot="header">
          <i 
            :class="isAllExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
            class="expand-icon pointer"
            @click="toggleExpandAll"
          />
        </template>
        <template slot-scope="{ row }">
          <div v-if="row.collectionType === 3 || row.collectionType === 1" class="expand-content" style="margin: 10px;">
            <el-table :data="row.inviteCodeList" border style="margin: 10px 0">
              <el-table-column label="邀请码" min-width="150">
                <div slot-scope="{ row: inviteRow }">{{ inviteRow.inviteCode }} {{ inviteRow.isUniversal ? '（万能码）' : '' }}</div>
              </el-table-column>
              <el-table-column label="有效日期" min-width="200">
                <template slot-scope="{ row: inviteRow }">
                  <span v-if="!inviteRow.startTime">永久有效</span>
                  <span v-else>{{ formatTimeStamp(inviteRow.startTime, 'YYYY-MM-DD') }} ~ {{ formatTimeStamp(inviteRow.endTime, 'YYYY-MM-DD') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="downloadCount" label="下载次数" width="100" align="center" />
              <el-table-column prop="viewCount" label="查看次数" width="100" align="center" />
              <el-table-column label="邀请码状态" width="100" align="center">
                <template slot-scope="{ row: inviteRow }">
                  <span :style="{ color: inviteRow.status === 1 ? '#67C23A' : '#F56C6C' }">
                    {{ inviteRow.status === 1 ? '可用' : '不可用' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="80" align="center">
        <template>
          <i class="el-icon-rank pointer cursor-move" style="font-size: 20px; color: #909399" />
        </template>
      </el-table-column>
      <el-table-column label="封面图" width="120" align="center">
        <template slot-scope="{ row }">
          <el-image
            v-if="row.homepageUrl || row.customUrl"
            :src="row.homepageUrl || row.customUrl"
            :preview-src-list="[row.homepageUrl || row.customUrl]"
            fit="cover"
            style="width: 100px; height: 60px; cursor: pointer"
          />
        </template>
      </el-table-column>
      <el-table-column prop="collectionName" label="集合名称" min-width="150" />
      <el-table-column label="邮箱" min-width="150">
        <template slot-scope="{ row }">
          <el-popover
            placement="bottom"
            width="260"
            trigger="hover">
            <div slot="reference">
              <div v-if="row.emailList[0]" class="ellipsis" :title="row.emailList[0]">{{ row.emailList[0] }}</div>
              <div v-if="row.emailList[1]" class="ellipsis" :title="row.emailList[1]">{{ row.emailList[1] }}</div>
            </div>
            <div>
              <div v-for="(email, index) in row.emailList" :key="index" class="ellipsis" :title="email">{{ email }}</div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="collectionType" label="集合类型" min-width="80">
        <div slot-scope="{ row }">{{ row.collectionType === 1 ? '首页' : row.collectionType === 2 ? '定制' : '首页定制' }}</div>
      </el-table-column>
      <el-table-column label="PDF文件" min-width="150">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.pdfName">{{ row.pdfName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="inviteCodeCount" label="邀请码数量" width="110" align="center" />
      <el-table-column prop="downloadCount" label="下载次数" width="100" align="center" />
      <el-table-column prop="viewCount" label="查看次数" width="100" align="center" />
      <el-table-column label="集合状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160">
        <template slot-scope="{ row }">
          {{ formatTimeStamp(row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="footer">
      <el-pagination
        background
        :current-page="pagination.pageNumber"
        :page-sizes="[20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 新增/编辑集合对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="940px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="collectionForm" :model="formData" :rules="formRules" label-width="120px">
        <el-form-item label="集合名称" prop="collectionName">
          <el-input
            v-model="formData.collectionName"
            placeholder="请输入集合名称(仅支持英文、数字、下划线)"
            maxlength="50"
            size="medium"
            @blur="handleBlur"
          />
        </el-form-item>
        <el-form-item label="PDF文件" prop="pdfUrl">
          <el-upload
            ref="pdfUpload"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            accept=".pdf"
            :on-change="handlePdfChange"
          >
            <el-button size="small" type="primary">
              {{ formData.pdfUrl ? '重新上传' : '选择文件' }}
            </el-button>
            <span v-if="formData.pdfName" style="margin-left: 10px">{{ formData.pdfName }}</span>

          </el-upload>
          <div class="upload-tip">支持pdf格式</div>
        </el-form-item>
        <el-form-item label="集合类型" prop="collectionType">
          <el-checkbox-group v-model="formData.collectionType">
            <el-checkbox :label="1">首页</el-checkbox>
            <el-checkbox :label="2">定制</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="formData.collectionType.includes(1)" label="首页封面" prop="homepageUrl">
          <div class="cover-upload-area">
            <div v-if="formData.homepageUrl" class="cover-preview">
              <img :src="formData.homepageUrl" />
              <div class="cover-mask">
                <i class="el-icon-edit" @click="handleChangeCover('home')" />
                <i class="el-icon-delete" @click="handleRemoveCover('home')" />
              </div>
            </div>
            <div v-else class="cover-placeholder" @click="handleChangeCover('home')">
              <i class="el-icon-plus" />
              <div>上传首页封面</div>
              <div>(支持png、jpg格式)</div>
            </div>
            <div>推荐尺寸（1200 x 848）</div>
            <!-- <canvas v-if="pages.length" :ref="`canvas_${pages[0].id}`" class="cover-canvas"></canvas> -->
            <el-upload
              ref="homeUpload"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              accept="image/png,image/jpg,image/jpeg"
              :on-change="file => handleCoverChange(file, 'home')"
              style="display: none"
            />
          </div>
          <!-- <div class="upload-tip">默认使用PDF第一页作为封面,也可上传图片(支持png、jpg格式)</div> -->
        </el-form-item>
        <el-form-item v-if="formData.collectionType.includes(2)" label="定制封面" prop="customUrl">
          <div class="cover-upload-area">
            <div v-if="formData.customUrl" class="cover-preview">
              <img :src="formData.customUrl" />
              <div class="cover-mask">
                <i class="el-icon-edit" @click="handleChangeCover('custom')" />
                <i class="el-icon-delete" @click="handleRemoveCover('custom')" />
              </div>
            </div>
            <div v-else class="cover-placeholder" @click="handleChangeCover('custom')">
              <i class="el-icon-plus" />
              <div>上传定制 封面</div>
              <div>(支持png、jpg格式)</div>
            </div>
            <div>推荐尺寸（1200 x 848）</div>
            <!-- <canvas v-if="pages.length" :ref="`canvas_${pages[0].id}`" class="cover-canvas"></canvas> -->
            <el-upload
              ref="customUpload"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              accept="image/png,image/jpg,image/jpeg"
              :on-change="file => handleCoverChange(file, 'custom')"
              style="display: none"
            />
          </div>
          <!-- <div class="upload-tip">默认使用PDF第一页作为封面,也可上传图片(支持png、jpg格式)</div> -->
        </el-form-item>
        <el-form-item v-if="formData.collectionType.includes(2)" label="指定客户邮箱" prop="emails">
          <!-- <el-select v-model="formData.customerEmail" placeholder="请选择客户邮箱">
            <el-option v-for="item in customerList" :key="item.id" :label="item.email" :value="item.email" />
          </el-select> -->
          <el-select v-model="formData.emails" size="medium" collapse-tags multiple filterable remote reserve-keyword placeholder="邮箱/手机号" style="width: 360px" :remote-method="userRemoteMethod" :loading="getUserLoading" @blur="userRemoteMethod" clearable>
            <el-option v-for="item in userOptions" :key="item" :label="item" :value="item" :title="item" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.collectionType.includes(1)" label="邀请码管理" prop="inviteCodeList">
          <div class="invite-code-manage">
            <el-button size="small" type="primary" @click="handleAddInviteCode">新增邀请码</el-button>
            <el-table :data="formData.inviteCodeList" border style="margin-top: 10px">
              <el-table-column prop="inviteCode" label="邀请码" min-width="160">
                <template slot-scope="{ row }">
                  <span>{{ row.inviteCode }}{{ row.isUniversal ? '（万能码）' : '' }}</span>
                </template>
              </el-table-column>

              <el-table-column label="有效日期" min-width="180">
                <template slot-scope="{ row }">
                  <span v-if="!row.startTime">永久有效</span>
                  <span v-else>{{ formatTimeStamp(row.startTime, 'YYYY-MM-DD') }} ~ {{ formatTimeStamp(row.endTime, 'YYYY-MM-DD') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="downloadCount" label="下载次数" width="90" align="center" />
              <el-table-column prop="viewCount" label="查看次数" width="90" align="center" />
              <el-table-column label="状态" width="90" align="center">
                <template slot-scope="{ row }">
                  <span :style="{ color: row.status === 1 ? '#67C23A' : '#F56C6C' }">
                    {{ row.status === 1 ? '可用' : '不可用' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90" align="center">
                <template slot-scope="{ row }">
                  <!-- <el-button type="text" @click="handleEditInviteCode(row, $index)">编辑</el-button> -->
                  <span v-if="row.isUniversal"></span>
                  <el-switch
                    v-else
                    v-model="row.status"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/编辑邀请码对话框 -->
    <el-dialog
      :title="inviteCodeDialogTitle"
      :visible.sync="inviteCodeDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      @close="handleInviteCodeDialogClose"
    >
      <el-form ref="inviteCodeForm" :model="inviteCodeFormData" :rules="inviteCodeFormRules" label-width="100px">
        <el-form-item label="邀请码" prop="inviteCode">
          <div class="f--c">
            <el-input
              v-model.trim="inviteCodeFormData.inviteCode"
              placeholder="请输入邀请码"
              maxlength="8"
              size="medium"
              style="flex: 1"
            />
            <el-button size="medium" style="margin-left: 10px" @click="generateInviteCode">生成</el-button>
          </div>
        </el-form-item>
        <el-form-item label="有效日期" prop="dateRange">
          <div class="f--c">
            <el-date-picker
              v-model="inviteCodeFormData.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="medium"
              :picker-options="pickerOptions"
              :disabled="inviteCodeFormData.isPermanent"
              value-format="yyyy-MM-dd"
              style="flex: 1"
            />
            <el-button
              size="medium"
              :type="inviteCodeFormData.isPermanent ? 'primary' : ''"
              style="margin-left: 10px"
              @click="togglePermanent"
            >
              永久
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="邀请码状态" prop="status">
          <el-switch
            v-model="inviteCodeFormData.status"
            :active-value="1"
            :inactive-value="0"
            active-text="可用"
            inactive-text="不可用"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" @click="inviteCodeDialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" @click="handleinviteCodeListubmit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 配置合集标题对话框 -->
    <el-dialog
      title="配置合集信息"
      :visible.sync="configVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="configForm" :model="configFormData" :rules="configFormRules" label-width="100px">
        <el-form-item label="集合系列名称" prop="collectionTitle">
          <el-input
            v-model="configFormData.collectionTitle"
            placeholder="请输入集合系列名称"
            size="medium"
          />
        </el-form-item>
        <el-form-item label="万能邀请码" prop="universalCode">
          <el-input
            v-model="configFormData.universalCode"
            placeholder="请输入万能邀请码"
            size="medium"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" @click="configVisible = false">取消</el-button>
        <el-button type="primary" size="medium" @click="handleCollectionTitleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { Sortable } from 'sortablejs'
import { formatTimeStamp } from '@/utils/moment'
import { base64ToFile } from '@/utils/index'
import _ from 'lodash'

// // 组件中引入（推荐方式）
// import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf'
// import pdfWorker from 'pdfjs-dist/es5/build/pdf.worker.entry'
// // 配置Worker路径
// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker
// // 安全配置（防止XSS漏洞）
// pdfjsLib.GlobalWorkerOptions.isEvalSupported = false

export default {
  name: 'CollectionConfig',
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入集合名称'))
      } else if (!/^[a-zA-Z0-9\s_]+$/.test(value)) {
        callback(new Error('仅支持英文、数字、下划线、空格'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入万能邀请码'))
      } else if (!/^[a-zA-Z0-9]{8}$/.test(value)) {
        callback(new Error('仅支持英文、数字, 8位字符长度'))
      } else {
        callback()
      }
    }
    const validateinviteCodeList = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('至少需要添加一条邀请码'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      searchParams: {
        collectionName: '',
        status: '',
        inviteCode: '',
        inviteCodeListtatus: '',
        collectionType: ''
      },
      tableData: [],
      expandRowKeys: [],
      tableKey: 0,
      isAllExpanded: false,
      pagination: {
        pageNumber: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增集合',
      submitLoading: false,
      formData: {
        id: null,
        collectionName: '',
        pdfUrl: '',
        pdfName: '',
        homepageUrl: '',
        customUrl: '',
        inviteCodeList: [],
        status: 1,
        emails: [],
        collectionType: [1]
      },
      formRules: {
        collectionName: [{ required: true, validator: validateName, trigger: 'blur' }],
        pdfUrl: [{ required: true, message: '请上传PDF文件', trigger: 'change' }],
        homepageUrl: [{ required: true, message: '请上传首页图片', trigger: 'change' }],
        customUrl: [{ required: true, message: '请上传定制图片', trigger: 'change' }],
        emails: [{ required: true, message: '请选择邮箱', trigger: 'change' }],
        inviteCodeList: [{ required: true, validator: validateinviteCodeList, trigger: 'change' }],
        collectionType: [{ required: true, message: '请选择集合类型', trigger: 'change' }],
      },
      inviteCodeDialogVisible: false,
      inviteCodeDialogTitle: '新增邀请码',
      inviteCodeFormData: {
        inviteCode: '',
        dateRange: [],
        isPermanent: false,
        status: 1
      },
      inviteCodeFormRules: {
        inviteCode: [{ required: true, message: '请输入邀请码', trigger: 'blur' }]
      },
      currentInviteCodeIndex: -1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      sortable: null,

      configVisible: false,
      configFormRules: {
        collectionTitle: [{ required: true, message: '请输入合集标题', trigger: 'blur' }],
        universalCode: [{ required: true, validator: validateCode, trigger: 'blur' }]
      },
      configFormData: {
        collectionTitle: '',
        universalCode: ''
      },

      getUserLoading: false,
      userOptions: [],

      // pages: [],
      // pdfDoc: null
    }
  },
  mounted() {
    this.getList()
    // this.initSortable()
    this.userRemoteMethod()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    formatTimeStamp(time, format = 'YYYY-MM-DD HH:mm:ss') {
      return formatTimeStamp(time, format)
    },
    // 获取列表
    getList() {
      this.loading = true
      const params = {
        ...this.searchParams,
        pageNumber: this.pagination.pageNumber,
        pageSize: this.pagination.pageSize
      }
      API.getLaunchCollectionList(params).then(res => {
        this.tableData = res.data.list.map(t => ({
          ...t,
          emailList: t.emails ? t.emails.split(';') : []
        })) || []
        this.pagination.total = res.data.total || 0
      }).finally(() => {
        this.isAllExpanded = true
        this.toggleExpandAll()
        this.loading = false
      })
    },

    async userRemoteMethod(query) {
      const params = {
        email: query ? query.trim() : '', // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: [],
      }
      this.getUserLoading = true
      let result = await API.getUserOptions(params)
      this.userOptions = result.data.list.map(t => t.email)
      this.getUserLoading = false
    },

    // 初始化拖拽排序
    initSortable() {
      this.$nextTick(() => {
        const el = this.$refs.collectionTable.$el.querySelector('.el-table__body-wrapper tbody')
        this.sortable = Sortable.create(el, {
          handle: '.el-icon-rank',
          animation: 150,
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return
            const movedItem = this.tableData.splice(oldIndex, 1)[0]
            this.tableData.splice(newIndex, 0, movedItem)
            this.updateSort()
          },
          onStart: () => {
            this.isAllExpanded = false
            this.expandRowKeys = []
          },
        })
      })
    },

    // 更新排序
    updateSort() {
      const sortData = this.tableData.map((item, index) => ({
        id: item.id,
        sort: index + 1
      }))
      API.sortLaunchCollection({
        ids: sortData.map(item => item.id)
      }).then(() => {
        this.$message.success('排序更新成功')
        this.getList()
      })
    },

    // 展开/收起
    handleExpandChange(row, expandedRows) {
      this.expandRowKeys = expandedRows.map(item => item.id)
      this.isAllExpanded = this.expandRowKeys.length === this.tableData.length
    },

    // 展开/收起全部
    toggleExpandAll() {
      this.tableKey++
      if (this.isAllExpanded) {
        this.isAllExpanded = false
        this.expandRowKeys = []
      } else {
        this.expandRowKeys = this.tableData.map(item => item.id)
        this.isAllExpanded = true
      }

      this.$nextTick(() => {
        this.initSortable()
      })
    },

    // 查询
    handleSearch() {
      this.pagination.pageNumber = 1
      this.getList()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增集合'
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑集合'
      this.formData = {
        id: row.id,
        collectionName: row.collectionName,
        pdfUrl: row.pdfUrl,
        pdfName: row.pdfName,
        pdfSize: row.pdfSize,
        homepageUrl: row.homepageUrl,
        customUrl: row.customUrl,
        inviteCodeList: row.inviteCodeList,
        status: row.status,
        emails: row.emails?.split(';') || [],
        collectionType: row.collectionType === 1 ? [1] : row.collectionType === 2 ? [2] : [1, 2],
      }
      this.userOptions = this.userOptions.filter(t => !this.formData.emails.includes(t))
      this.userOptions.unshift(...this.formData.emails)
      this.dialogVisible = true
    },

    handleBlur() {
      // 失去焦点去除前后空格
      this.formData.collectionName = this.formData.collectionName.trim()
    },

    // 状态切换
    handleStatusChange(row) {
      API.editLaunchCollectionStatus({
        id: row.id,
        status: row.status
      }).then(() => {
        this.$message.success('状态更新成功')
        this.getList()
      })
    },

    // PDF上传
    handlePdfChange(file) {
      const isPdf = file.raw.type === 'application/pdf'
      if (!isPdf) {
        this.$message.error('只支持pdf格式的文件')
        return
      }

      API.signValue({ directory: 'pushCollection/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'pushCollection/')
        formData.append('signValue', data)
        formData.append('file', file.raw)
        API.uploadUniversalFile(formData).then(result => {
          this.formData.pdfUrl = result.data
          this.formData.pdfName = file.name
          this.formData.pdfSize = (file.size/1024/1024).toFixed(2)
          this.$refs.collectionForm.clearValidate('pdfUrl')

          // 默认使用PDF第一页作为封面
          // this.loadPdf(result.data)
        })
      })
    },

    // 封面上传
    handleChangeCover(type) {
      if (type === 'home') {
        this.$refs.homeUpload.$children[0].$refs.input.click()
      } else if (type === 'custom') {
        this.$refs.customUpload.$children[0].$refs.input.click()
      }
    },

    handleCoverChange(file, type) {
      if (file.raw) {
        file = file.raw
      }

      const isImage = ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)
      if (!isImage) {
        this.$message.error('只支持png、jpg格式的图片')
        return
      }

      API.signValue({ directory: 'pushCollection/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'pushCollection/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then(result => {
          if (type === 'home') {
            this.formData.homepageUrl = result.data
          } else if (type === 'custom') {
            this.formData.customUrl = result.data
          }
        })
      })
    },

    handleRemoveCover(type) {
      if (type === 'home') {
        this.formData.homepageUrl = ''
      } else if (type === 'custom') {
        this.formData.customUrl = ''
      }
    },

    // 新增邀请码
    handleAddInviteCode() {
      this.inviteCodeDialogTitle = '新增邀请码'
      this.currentInviteCodeIndex = -1
      this.inviteCodeDialogVisible = true
      this.generateInviteCode()
    },

    // 编辑邀请码
    handleEditInviteCode(row, index) {
      this.inviteCodeDialogTitle = '编辑邀请码'
      this.currentInviteCodeIndex = index
      this.inviteCodeFormData = {
        inviteCode: row.inviteCode,
        dateRange: row.isPermanent ? [] : [row.startTime, row.endTime],
        isPermanent: row.isPermanent,
        status: row.status
      }
      this.inviteCodeDialogVisible = true
    },

    // // 删除邀请码
    // handleDeleteInviteCode(index) {
    //   if (this.formData.inviteCodeList.length === 1) {
    //     this.$message.warning('至少需要保留一条邀请码')
    //     return
    //   }
    //   this.$confirm('确认删除该邀请码?', '提示', {
    //     type: 'warning'
    //   }).then(() => {
    //     this.formData.inviteCodeList.splice(index, 1)
    //     this.$refs.collectionForm.validateField('inviteCodeList')
    //   }).catch(() => {})
    // },

    // 生成邀请码
    generateInviteCode() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let code = ''
      for (let i = 0; i < 8; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.$set(this.inviteCodeFormData, 'inviteCode', code)
    },

    // 切换永久有效
    togglePermanent() {
      this.inviteCodeFormData.isPermanent = !this.inviteCodeFormData.isPermanent
      if (this.inviteCodeFormData.isPermanent) {
        this.inviteCodeFormData.dateRange = []
      }
    },

    // 邀请码提交
    handleinviteCodeListubmit() {
      this.$refs.inviteCodeForm.validate(valid => {
        if (!valid) return
        if (!this.inviteCodeFormData.isPermanent && (!this.inviteCodeFormData.dateRange || this.inviteCodeFormData.dateRange.length === 0)) {
          this.$message.warning('请选择有效日期或设置为永久有效')
          return
        }

        const inviteCodeData = {
          inviteCode: this.inviteCodeFormData.inviteCode,
          startTime: this.inviteCodeFormData.isPermanent ? '' : this.inviteCodeFormData.dateRange[0],
          endTime: this.inviteCodeFormData.isPermanent ? '' : this.inviteCodeFormData.dateRange[1],
          isPermanent: this.inviteCodeFormData.isPermanent,
          status: this.inviteCodeFormData.status,
          downloadCount: 0,
          viewCount: 0
        }

        if (this.currentInviteCodeIndex === -1) {
          this.formData.inviteCodeList.push(inviteCodeData)
        } else {
          this.$set(this.formData.inviteCodeList, this.currentInviteCodeIndex, inviteCodeData)
        }

        this.$refs.collectionForm.validateField('inviteCodeList')
        this.inviteCodeDialogVisible = false
      })
    },

    // 邀请码对话框关闭
    handleInviteCodeDialogClose() {
      this.$refs.inviteCodeForm.resetFields()
      this.inviteCodeFormData = {
        inviteCode: '',
        dateRange: [],
        isPermanent: false,
        status: 1
      }
      this.currentInviteCodeIndex = -1
    },

    // 提交表单
    handleSubmit() {
      this.$refs.collectionForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true

        const params = _.cloneDeep(this.formData)
        params.collectionType = params.collectionType.join(',') === '1,2' ? 3 : +params.collectionType.join(',')

        if (params.collectionType === 3 || params.collectionType === 1) {
          params.inviteCodeList = params.inviteCodeList.map(item => ({
            ...item,
            startTime: item.isPermanent ? '' : item.startTime,
            endTime: item.isPermanent ? '' : item.endTime
          }))
        } else {
          params.inviteCodeList = undefined
        }

        if (params.collectionType === 3 || params.collectionType === 2) {
          params.emails = params.emails.join(';')
        } else {
          params.emails = undefined
        }


        API.editLaunchCollection(params).then(() => {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.submitLoading = false
          this.getList()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.collectionForm.resetFields()
      this.formData = {
        id: null,
        collectionName: '',
        pdfUrl: '',
        pdfName: '',
        pdfSize: '',
        coverUrl: '',
        inviteCodeList: [],
        status: 1,
        emails: [],
        collectionType: [1]
      }
    },

    // 分页
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNumber = 1
      this.getList()
    },
    handlePageChange(page) {
      this.pagination.pageNumber = page
      this.getList()
    },

    handleShowConfig() {
      this.configVisible = true
      API.getLaunchCollectionConfig().then(res => {
        this.configFormData = res.data
      })
    },

    handleCollectionTitleSubmit() {
      this.$refs.configForm.validate(valid => {
        if (!valid) return
        const params = { ...this.configFormData }
        API.saveLaunchCollectionConfig(params).then(() => {
          this.$message.success('操作成功')
          this.configVisible = false
          this.getList()
        })
      })
    }
  
    // async loadPdf(url) {
    //   const loadingTask = pdfjsLib.getDocument(url)
    //   this.pdfDoc = await loadingTask.promise
    //   this.pages = Array.from({ length: this.pdfDoc.numPages }, (_, i) => ({ id: i + 1 }))
      
    //   this.$nextTick(() => {
    //     this.renderAllPages()
    //   })
    // },
    // async renderAllPages() {
    //   for (let i = 1; i <= this.pdfDoc.numPages; i++) {
    //     const page = await this.pdfDoc.getPage(i)
    //     const viewport = page.getViewport({ scale: 1.5 })

    //     const canvas = this.$refs[`canvas_${i}`]
    //     if (canvas) {
    //       const context = canvas.getContext('2d')
    //       canvas.width = viewport.width
    //       canvas.height = viewport.height
    //       await page.render({
    //         canvasContext: context,
    //         viewport
    //       }).promise
    //       let file = base64ToFile(canvas.toDataURL("image/png"), this.formData.pdfName)
    //       this.handleCoverChange(file)
    //     }
    //   }
    // },

  }
}
</script>

<style lang="scss" scoped>
.cover-canvas {
  position: absolute;
  opacity: 0;
}

.collection-config {
  .filter-bar {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
  }

  .expand-content {
    background: #f5f7fa;
  }

  .footer {
    margin-top: 20px;
    text-align: right;
  }

  .cover-upload-area {
    .cover-preview {
      position: relative;
      width: 300px;
      height: 180px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .cover-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 0.3s;

        i {
          font-size: 20px;
          color: #fff;
          margin: 0 10px;
          cursor: pointer;

          &:hover {
            color: #99c41c;
          }
        }
      }

      &:hover .cover-mask {
        opacity: 1;
      }
    }

    .cover-placeholder {
      width: 300px;
      height: 180px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: border-color 0.3s;

      &:hover {
        border-color: #99c41c;
      }

      i {
        font-size: 28px;
        color: #8c939d;
        margin-bottom: 8px;
      }

      div {
        font-size: 14px;
        color: #8c939d;
        line-height: 20px;
      }
    }
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }

  .invite-code-manage {
    width: 100%;
  }

  .expand-icon {
    font-size: 16px;
    color: #606266;
    transition: transform 0.3s;

    &:hover {
      color: #99c41c;
    }
  }
}
</style>
